import React from "react";
import Footer from "../components/ui/Footer/Footer";
import NavbarShared from "../components/ui/NavbarShared/NavbarShared"
import RestaurantsCards from "../components/ui/RestaurantsCards/RestaurantsCards";

function Restaurants() {
  return (
    <div>
      <NavbarShared />
      <div>
        <RestaurantsCards />
      </div>
      <Footer />
    </div>
  )
}

export default Restaurants